import React from 'react';
import ContentLayout from 'src/components/ContentLayout';
import Link from 'src/components/Link';
import Text from 'src/components/Text';
import routes from 'src/constants/routes'
import styles from './styles.module.scss';

const Offer: React.FC = () => {
  return (
    <ContentLayout size="medium" className={styles['root']}>
      <Text type="p" className={styles['header-text']}>Редакция от 01 августа 2023 года</Text>
      <Text type="h1" className={styles['h1']}>
        Соглашение об условиях использования программы для ЭВМ «Агент 1C:СБП»
      </Text>
      <Text type="h2">1. Общие положения</Text>
      <ul>
        <li>
          <Text type="p">
            1.1.	Настоящее Соглашение об условиях использования программы для ЭВМ «Агент 1С:СБП» (далее - Программа)
            представляет собой предложение ЗАО «ИнфорАС» (далее – Агент ТСП) юридическим лицам и индивидуальным
            предпринимателям (далее – Пользователь) присоединиться к условиям использования Программы на изложенных
            ниже условиях.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.2.	Программа размещена в сети Интернет по адресу https://sbp.1c.ru. Программа обеспечивает содействие
            в генерации и получении токена (уникального буквенно-цифрового кода) по запросу Пользователя, введение
            которого в устройствах Пользователя (представляемых им ТСП) позволит формировать и отображать на них QR-код
            в целях оплаты физическими лицами (клиентами) товаров (работ, услуг) в платежной системе «Система быстрых
            платежей» Банка России (СБП).
          </Text>
        </li>
        <li>
          <Text type="p">
            1.3.	Агент ТСП, являясь правообладателем Программы, осуществляет свою деятельность по информационно-техническому
            взаимодействию с АО «НСПК», кредитными организациями и ТСП в соответствии с «Правилами информационно-технологического
            взаимодействия Агента ТСП, Банка, АО «НСПК» при использовании QR-кодов в целях оплаты товаров (работ, услуг) в СБП»
            (размещены по адресу https://sbp.nspk.ru/).
          </Text>
        </li>
        <li>
          <Text type="p">
            1.4.	В целях настоящего Соглашения под ТСП понимается торгово-сервисное предприятие, которое находится
            под управлением юридического лица (организации) или индивидуального предпринимателя, заключившего с
            кредитной организацией, являющейся участником СБП, договор банковского обслуживания, предусматривающий
            совершение оплаты клиентом товаров (работ, услуг) с использованием СБП, и в отношении которого Пользователь
            подтверждает свои полномочия по использованию Программы в их интересах определяемым Агентом ТСП способом.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.5.	В соответствии со ст.437, 438 ГК РФ присоединение Пользователя к условиям настоящего Соглашения
            осуществляется с момента получения согласия Пользователя с условиями настоящего Соглашения путем совершения
            его полномочным представителем следующей последовательности действий, а именно:
          </Text>
          <Text type="p">
            - авторизация с использованием абонентского номера оператора подвижной радиотелефонной сети представителя
            Пользователя путем ввода кода из поступившего СМС-уведомления (указанный абонентский номер используется как
            идентификатор Пользователя при получении доступа к функционалу Программу);
          </Text>
          <Text type="p">
            - генерация пароля, который в последующем совместно с ранее введенным абонентским номером оператора
            подвижной радиотелефонной сети, обеспечит доступ к функционалу Программы;
          </Text>
          <Text type="p">
            - ввод данных представителя Пользователя в объеме, предусмотренном Программой;
          </Text>
          <Text type="p">
            - подтверждение полномочий представителя Пользователя с использованием усиленной квалифицированной
            электронной подписи (УКЭП) способами, предусмотренными функционалом Программы;
          </Text>
          <Text type="p">
            - выражение согласия с условиями настоящего Соглашения путем проставления в предусмотренном поле (чекбоксе)
            электронной отметки (галки) и его подтверждение путем нажатия последующей за этим действием кнопки.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.6. Пользователь безоговорочно соглашается с тем, что факт выполнения определенной выше последовательности
            действий его представителем, в том числе с использованием технических инструментов, автозагрузки, выполнение
            команд через интерфейсные элементы Программы (нажатие кнопок, проставление галок, загрузка файлов и пр.)
            и иные подобные действия, означают волеизъявление Пользователя на присоединение к Соглашению.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.7. Присоединяясь к условиям настоящего Соглашения, Пользователь в лице своего представителя подтверждает,
            что ознакомился с ними и принимает их в полном объеме без каких-либо ограничений, а также дает согласие
            Агенту ТСП на обмен сведениями о ТСП (ИНН, ОГРН, номер расчётного счёта, идентификаторы ТСП в СБП и т.п.),
            которые предоставляются им при использовании Программы, с АО «НСПК» и кредитными организациями в целях
            генерации, получения и последующего использования токенов.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.8. Представитель Пользователя не вправе передавать авторизационные данные третьим лицам и обязуется
            обеспечивать сохранность и конфиденциальность этих данных. Все действия, осуществленные в Программе с
            использованием авторизационных данных представителя Пользователя, считаются осуществленными Пользователем.
            Агент ТСП не несет какой-либо ответственности за несанкционированное использование авторизационных данных
            представителя Пользователя третьими лицами.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.9. Настоящее Соглашение постоянно размещено в сети Интернет по адресу{' '}
            <Link to={routes.offer} target="_blank">https://sbp.1c.ru/ui/offer</Link>.
          </Text>
          <Text type="p">
            В период действия Соглашения могут приниматься его новые редакции, которые в обязательном порядке
            размещаются на сайте www.sbp.1c.ru, в связи с чем Пользователь обязуется самостоятельно отслеживать все
            изменения в условиях Соглашения путем ознакомления с их содержанием на страницах сайта www.sbp.1c.ru.
            Новая редакция Cоглашения вступает в силу по истечении 5 (пяти) календарных дней с даты ее размещения,
            при условии, что Пользователь не уведомил Агента ТСП о несогласии с новой редакцией до вступления ее в силу.
            Если Пользователь уведомил Агента ТСП о несогласии с новой редакцией Соглашения, это рассматривается как
            односторонний отказ Пользователя от исполнения Соглашения, что может за собой повлечь прекращение доступа
            Пользователя (его представителей) к Программе.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.10. Агент ТСП не несет ответственности, если информация об изменении Соглашения, принятия новой редакции
            не была получена, и/или изучена, и/или правильно понята Пользователем.
          </Text>
        </li>
        <li>
          <Text type="p">
            1.11. Любые изменения Соглашения с момента их вступления в силу распространяются на всех лиц, присоединившихся
            к Соглашению, в том числе присоединившихся к Соглашению ранее даты вступления изменений (новой редакции) в силу.
          </Text>
        </li>
      </ul>
      <Text type="h2">2. Условия генерации и использования токенов</Text>
      <ul>
        <li>
          <Text type="p">
            2.1. Запрос на генерацию токенов для ТСП может быть сформирован представителем Пользователя, который прошел
            процедуру подтверждения полномочий при присоединении к условиям Соглашения, либо иным лицом, который
            впоследствии получил электронное приглашение от подтвержденного представителя Пользователя присоединиться
            к организации в качестве ее дополнительного представителя с использованием инструментов Программы. Для
            дополнительного представителя  предусматривается процедура авторизации, аналогичная той, что предусмотрена
            п.1.5 Соглашения, за исключением необходимости подтверждения полномочий с использованием УКЭП.  Плата за
            генерацию токенов Агентом ТСП не предусматривается.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.2. Для генерации токенов для ТСП представителю Пользователя необходимо следовать инструкциям Программы.
            При этом генерация токенов для ТСП возможна при условии, что кредитная организация, в которой у
            Пользователя открыт расчетный счет, является участником СБП, и с данной кредитной организацией у
            Пользователя имеется действующий договор банковского обслуживания, предусматривающий совершение оплаты
            клиентом товаров (работ, услуг) с использованием СБП.
          </Text>
          <Text type="p">
            Представитель Пользователя самостоятельно вводит актуальный набор реквизитов ТСП как юридического лица
            или индивидуального предпринимателя, предусмотренный формами Программы и необходимый для генерации токена.
            Контроль действительности и корректности вводимых данных Агентом ТСП не осуществляется.
          </Text>
          <Text type="p">
            В случае если при обмене информации с АО «НСПК» подтверждается несоблюдение данных условий, Пользователю
            Программы предлагается обратиться в кредитную организацию.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.3. Сгенерированный токен используется ТСП путем введения на устройстве Пользователя (представляемых им
            ТСП), что позволит формировать и отображать на них QR-код в целях оплаты физическими лицами (клиентами)
            товаров (работ, услуг) в СБП. Условия использования устройств, в том числе условия возможного взимания
            платы за совершение операций с использованием QR-кода, определяются правообладателями таких устройств
            и/или используемых в них программ для ЭВМ. Пользователь самостоятельно уточняет наличие таких условий,
            а также совершает все необходимые действия (установка, настройка и т.п.), в том числе вносит платежи
            в пользу правообладателя, если таковые предусмотрены.
          </Text>
        </li>
        <li>
          <Text type="p">
            2.4. Функционал Программы предусматривает возможность управлять токенами для ТСП, в частности отзывать,
            перевыпускать. Данные действия осуществляются по усмотрению представителей Пользователя, как они
            определены в п.2.1 Соглашения, которые несут всю ответственность за их последствия. При этом Пользователю
            известно, что возможность управления токенами зависит от актуальности сведений о ТСП в Программе, от
            соблюдения условий, предусмотренных п.2.2 Соглашения, от действующих на этот момент правил и стандартов
            АО «НСПК», и в ряде случаев может потребовать от Пользователя совершения действий по обновлению в
            Программа информации о ТСП, а также взаимодействию с кредитной организацией.
          </Text>
        </li>
      </ul>
      <Text type="h2">3. Права и обязанности</Text>
      <ul>
        <li>
          <Text type="p">
            3.1. Агент ТСП вправе:
          </Text>
        </li>
        <li>
          <Text type="p">
            3.1.1. в одностороннем порядке вносить изменения в настоящее Соглашение, в том числе путем утверждения
            его новой редакции;
          </Text>
        </li>
        <li>
          <Text type="p">
            3.1.2. вносить изменения и дополнения в Программу в связи с изменением порядка осуществления
            информационно-технологическом взаимодействия, определяемого в правилах и стандартах АО «НСПК»;
          </Text>
        </li>
        <li>
          <Text type="p">
            3.1.3. вправе временно приостанавливать функционирование Программы по причинам технологического характера
            (профилактические работы, обновление программного или аппаратного обеспечения и т.п.);
          </Text>
        </li>
        <li>
          <Text type="p">
            3.1.4. осуществлять информационные рассылки по контактам представителей Пользователя в связи с действием
            настоящего Соглашения и функционированием Программы. Пользователь соглашается с тем, что адреса электронной
            почты, указанные представителем Пользователя при присоединении к Соглашению, будут использоваться для
            информационного взаимодействия. Направление Агентом ТСП сообщений на указанные адреса электронной почты
            признается надлежащим уведомлением Пользователя о юридически значимых действиях и событиях.
          </Text>
        </li>
        <li>
          <Text type="p">
            3.2. Пользователь вправе:
          </Text>
        </li>
        <li>
          <Text type="p">
            3.2.1. самостоятельно определять количество и перечень своих представителей в целях использования Программы
            и управлять ими (путем добавления новых представителей и удаления тех, правомочия которых прекращены);
          </Text>
        </li>
        <li>
          <Text type="p">
            3.2.2. самостоятельно управлять перечнем ТСП, для которых необходима генерация токенов. При этом в
            некоторых случаях может потребоваться подтверждение полномочий Пользователя (его представителя) действовать
            в интересах ТСП, предусмотренными в Программе способами;
          </Text>
        </li>
        <li>
          <Text type="p">
            3.2.3. самостоятельно управлять токенами для ТСП с учетом условий, обозначенных в п.2.4 Соглашения;
          </Text>
        </li>
        <li>
          <Text type="p">
            3.2.4. инициировать запросы на удаление всех сведений о ТСП из Программы и/или признании ранее
            сгенерированных для него токенов недействительными. Порядок направления и рассмотрения таких запросов
            определяется Агентом ТСП.
          </Text>
        </li>
        <li>
          <Text type="p">
            3.3. Пользователь обязан:
          </Text>
        </li>
        <li>
          <Text type="p">
            3.3.1. соблюдать положения условий настоящего Соглашения, а также применимые нормы действующего
            законодательства Российской Федерации;
          </Text>
        </li>
        <li>
          <Text type="p">
            3.3.2. самостоятельно обеспечивать безопасность используемых устройств, программно-аппаратных комплексов
            и информационных систем, задействованных в период действия настоящего Соглашения, и самостоятельно нести
            риски, связанные с неправомерным доступом к ним третьих лиц.
          </Text>
        </li>
      </ul>
      <Text type="h2">4. Ответственность</Text>
      <ul>
        <li>
          <Text type="p">
            4.1. Агент ТСП будет предпринимать разумные усилия для устранения каких-либо сбоев и ошибок в
            функционировании Программы, тем не менее Агент ТСП не гарантирует полного отсутствия ошибок и сбоев и
            оставляет за собой право приостанавливать услуги по генерации и управлению токенами по причинам
            технологического характера на время устранения ошибок и сбоев.
          </Text>
        </li>
        <li>
          <Text type="p">
            4.2.  Агент ТСП не несет ответственность:
          </Text>
          <Text type="p">
            - за функционирование СБП;
          </Text>
          <Text type="p">
            - за частичное или полное невыполнение своих обязательств в соответствии с настоящим Соглашением, если
            данное невыполнение явилось следствием обстоятельств, возникших в результате технических проблем вне
            компетенции Агента ТСП, в частности возникших на стороне АО «НСПК» или кредитной организации;
          </Text>
          <Text type="p">
            - за любые убытки, причиненные Пользователю в результате ошибок и сбоев программного обеспечения или
            оборудования, как принадлежащих, так и не принадлежащих Агенту ТСП, в результате недоступности отдельных
            сегментов сети Интернет (в том числе в связи с прекращением функционирования сайтов третьих лиц, в том
            числе правообладателей программного обеспечения/оборудования), неисправности оборудования Пользователя,
            невозможности ТСП совершать операции в СБП;
          </Text>
          <Text type="p">
            - за убытки, расходы, а также иные негативные последствия, которые могут возникнуть в результате получения
            третьими лицами авторизационных данных представителей Пользователя. Пользователь обязан незамедлительно
            сообщать Агенту ТСП об обнаружении попытки несанкционированного доступа к Программе;
          </Text>
          <Text type="p">
            - за проведение операций, совершаемых ТСП с использованием QR-кодов в СБП, а также по спорам, возникающим
            между ТСП и его клиентами.
          </Text>
        </li>
        <li>
          <Text type="p">
            4.3. Пользователь несет всю ответственность за достоверность сведений, указываемых им при авторизации и
            использовании Программы.
          </Text>
        </li>
      </ul>
      <Text type="h2">5. Срок действия Соглашения</Text>
      <ul>
        <li>
          <Text type="p">
            5.1. Соглашение заключается на неопределенный срок.
          </Text>
        </li>
        <li>
          <Text type="p">
            5.2. Стороны пришли к соглашению, что в случае прекращения действия «Правил информационно-технологического
            взаимодействия Агента ТСП, Банка, АО «НСПК» при использовании QR-кодов в целях оплаты товаров (работ, услуг)
            в СБП», в том числе по инициативе Агента ТСП, последний вправе в одностороннем внесудебном порядке отказаться
            от исполнения настоящего Соглашения со дня прекращения действия указанных Правил. Агент ТСП информирует
            Пользователя о прекращении действия Соглашения путем направления на электронный адрес представителя Пользователя,
            который осуществлял присоединение к Соглашению, соответствующего уведомления либо путем размещения соответствующей
            информации непосредственно в Программе (при наличии технической возможности).
          </Text>
        </li>
      </ul>
      <Text type="h2">6. Иные условия</Text>
      <ul>
        <li>
          <Text type="p">
            6.1. Присоединяясь к Соглашению, Пользователь понимает и соглашается с тем, что работоспособность СБП
            (в том числе при совершении операций с использованием  QR-кодов) обеспечивает АО «НСПК».
          </Text>
        </li>
        <li>
          <Text type="p">
            6.2. Отношения, возникающие у Пользователей с АО «НСПК», а также иными лицами, обеспечивающими проведение
            операций в СБП, регулируются отдельными и самостоятельными соглашениями с такими лицами.
          </Text>
        </li>
        <li>
          <Text type="p">
            6.3. Присоединяясь к Соглашению и используя Программу, Пользователь (его представитель) как субъект
            персональных данных предоставляет Агенту ТСП свои персональные данные в целях надлежащего исполнения
            настоящего Соглашения и иных законных целях. Обработка персональных данных в рамках настоящего Соглашения
            включает в себя совершение Агентом ТСП действий, предусмотренных пунктом 3 части 1 статьи 3 Федерального
            закона от 27 июля 2006 года №152-ФЗ «О персональных данных» (в последующих редакциях), включая, но не
            ограничиваясь: сбор, систематизацию, накопление, хранение, уточнение, использование, передача (предоставление
            доступа) третьим лицам, обезличивание, блокирование, уничтожение, а также осуществление любых иных действий
            с персональными данными, предусмотренных действующим законодательством Российской Федерации. Обработка
            персональных данных может быть, как автоматизированная, так и без использования средств автоматизации.
            Цели сбора, а также основные направления деятельности в области обработки и защиты персональных данных
            изложены в Политике в отношении обработки и защите персональных данных Агента ТСП, доступной для ознакомления
            по адресу <Link to={routes.privacyPolicy} target="_blank">https://sbp.1c.ru/ui/privacyPolicy</Link>.
          </Text>
        </li>
        <li>
          <Text type="p">
            6.4. Отношения Сторон в рамках настоящего Соглашения регулируются в соответствии с действующим
            законодательством Российской Федерации. В случае разногласий споры, которые не могут быть разрешены путем
            переговоров Сторон, урегулируются в порядке, предусмотренном действующим законодательством. Рассмотрение
            споров, в том числе в судебном порядке, производится по месту государственной регистрации Агента ТСП – в
            городе Москва.
          </Text>
        </li>
        <li>
          <Text type="p">
            6.5. Агент ТСП не принимает на себя никаких условий и обязательств, помимо прямо указанных в тексте
            настоящего Соглашения.
          </Text>
        </li>
        <li>
          <Text type="p">
            6.6. Если какое-либо положение настоящего Соглашения является или становится недействительным в силу
            противоречия или внесения изменений в действующее законодательство Российской Федерации, правила и
            стандарты АО «НСПК», то это не является основанием для приостановления действия остальных положений
            настоящего Соглашения.
          </Text>
        </li>
      </ul>
      <Text type="p">
        РЕКВИЗИТЫ АГЕНТА ТСП:
      </Text>
      <Text type="p">
        Закрытое акционерное общество АО «ИнфорАС»
      </Text>
      <Text type="p">
        127434, г. Москва, ш. Дмитровское, д. 9, эт/ком 3/63
      </Text>
      <Text type="p">
        ИНН 7706249306
      </Text>
      <Text type="p">
        КПП 771301001
      </Text>
      <Text type="p">
        ОГРН 1027739157214
      </Text>
      <Text type="p">
        E-mail: <a href="mailto:sbp@1c.ru">sbp@1c.ru</a>
      </Text>
      <Text type="p">
        Генеральный директор
      </Text>
      <Text type="p">
        Голицына Людмила Владимировна
      </Text>
    </ContentLayout>
  );
};

export default Offer;
